import transactionCenter from "../../api/transactionCenter";

const state = {
    orderList: {},
    orderListLoading: false,
    orderListFilter: {},
};

const getters = {};
const mutations = {
    setData(state, {key, value}) {
        state[key] = value;
    },
    clearFilter(state) {
        state.orderListFilter = {};
    },
};
const actions = {
    // eslint-disable-next-line no-empty-pattern
    async getOrderResponseList({commit}, payload) {
        commit("setData", {key: "orderListLoading", value: true});
        try {
            let params = {};
            // 为了处理 过滤参数和分页器参数
            if (
                state.orderListFilter.dateRange &&
                state.orderListFilter.dateRange.length === 2
            ) {
                params = {
                    size: state.orderList.size,
                    ...state.orderListFilter,
                    ...payload,
                    startTime: state.orderListFilter.dateRange
                        ? state.orderListFilter.dateRange[0]
                        : null,
                    endTime: state.orderListFilter.dateRange
                        ? state.orderListFilter.dateRange[1]
                        : null,
                };
            } else {
                params = {
                    size: state.orderList.size,
                    ...state.orderListFilter,
                    ...payload,
                };
            }
            const res = await transactionCenter.getOrderResponseList.getList(params);
            commit("setData", {key: "orderList", value: res.data});
        } finally {
            commit("setData", {key: "orderListLoading", value: false});
        }
    },
    async setOrderFree({commit}, payload) {
        return await transactionCenter.setOrderFree(payload);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
